// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"170":"css/app","249":"css/backend","857":"css/other"}[chunkId] + ".css";
};